import React from 'react';
import { BathProps } from '@src/v3/interfaces/assets/svg';

const Bath = ({
  width = '20',
  height = '20',
  viewBox = '0 0 20 20',
  stroke = '#666666',
  strokeWidth,
  strokeLinecap,
  strokeLinejoin,
  useNewPaths = false,
  ...props
}: BathProps) => {
  // Old path data (default)
  const oldPaths = [
    { d: 'M5.625 15V16.875' },
    { d: 'M14.375 15V16.875' },
    { d: 'M15.625 7.5H10.625V11.25H15.625V7.5Z' },
    {
      d: 'M15.625 8.125H18.75V11.25C18.75 12.2446 18.3549 13.1984 17.6517 13.9017C16.9484 14.6049 15.9946 15 15 15H5C4.00544 15 3.05161 14.6049 2.34835 13.9017C1.64509 13.1984 1.25 12.2446 1.25 11.25V8.125H10.625',
    },
    {
      d: 'M4.375 8.125V4.0625C4.375 3.6481 4.53962 3.25068 4.83265 2.95765C5.12567 2.66462 5.5231 2.5 5.9375 2.5C6.30139 2.49915 6.65466 2.6226 6.93881 2.84993C7.22297 3.07725 7.42096 3.3948 7.5 3.75',
    },
  ];

  // New path data
  const newPaths = [
    { d: 'M4.5 12V13.5' },
    { d: 'M11.5 12V13.5' },
    { d: 'M12.5 6H8.5V9H12.5V6Z' },
    {
      d: 'M12.5 6.5H15V9C15 9.79565 14.6839 10.5587 14.1213 11.1213C13.5587 11.6839 12.7956 12 12 12H4C3.20435 12 2.44129 11.6839 1.87868 11.1213C1.31607 10.5587 1 9.79565 1 9V6.5H8.5',
    },
    {
      d: 'M3.5 6.5V3.25C3.5 2.91848 3.6317 2.60054 3.86612 2.36612C4.10054 2.1317 4.41848 2 4.75 2C5.04111 1.99932 5.32373 2.09808 5.55105 2.27994C5.77837 2.4618 5.93676 2.71584 6 3',
    },
  ];

  const paths = useNewPaths ? newPaths : oldPaths;
  const defaultStrokeWidth = useNewPaths ? '1.5' : undefined;
  const defaultStrokeLinecap = useNewPaths ? 'round' : undefined;
  const defaultStrokeLinejoin = useNewPaths ? 'round' : undefined;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      {...props}
    >
      {paths.map((path, index) => (
        <path
          key={index}
          d={path.d}
          stroke={stroke}
          strokeWidth={strokeWidth ?? defaultStrokeWidth}
          strokeLinecap={strokeLinecap ?? defaultStrokeLinecap}
          strokeLinejoin={strokeLinejoin ?? defaultStrokeLinejoin}
        />
      ))}
    </svg>
  );
};

export default Bath;
